import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getPharmacyServices({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/services`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getPharmacyService({ pharmacyId, serviceId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/services/${serviceId}`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async deletePharmacyService({ pharmacyId, serviceId }) {
    try {
      const response = await axiosPrivate.delete(`/pharmacies/${pharmacyId}/services/${serviceId}`);

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },

  async saveServiceContent({ pharmacyId, serviceId, content, shortDescription, contentJson }) {
    try {
      const response = await axiosPrivate.put(
        `/pharmacies/${pharmacyId}/services/${serviceId}/content`,
        {
          content,
          short_description: shortDescription,
          content_json: contentJson,
        },
        { headers: { 'accept-version': '2.0.0' } }
      );

      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },

  async getServiceChargeOptions({ serviceId }) {
    try {
      const response = await axiosPrivate.get(`/v3/pharmacist/services/${serviceId}/charge-options`);

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },

  async updateServiceChargeOptions({ serviceId, payload }) {
    try {
      const response = await axiosPrivate.put(`/v3/pharmacist/services/${serviceId}/charge-options`, payload);

      if (response.data.error) helpers.throwError(response.data.error);
      return response.data;
    } catch (error) {
      if (error?.response?.data?.error?.text) throw new Error(error.response.data.error.text);
      throw error;
    }
  },
};
